import { render, staticRenderFns } from "./VariantSifterAncestryBubbles.vue?vue&type=template&id=9fc8c770&scoped=true&"
import script from "./VariantSifterAncestryBubbles.vue?vue&type=script&lang=js&"
export * from "./VariantSifterAncestryBubbles.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterAncestryBubbles.vue?vue&type=style&index=0&id=9fc8c770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc8c770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fc8c770')) {
      api.createRecord('9fc8c770', component.options)
    } else {
      api.reload('9fc8c770', component.options)
    }
    module.hot.accept("./VariantSifterAncestryBubbles.vue?vue&type=template&id=9fc8c770&scoped=true&", function () {
      api.rerender('9fc8c770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterAncestryBubbles.vue"
export default component.exports